import { isEmpty } from "lodash/fp";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { CreditReviewInformationFields } from "globalConstants";
import { getErrorMessage } from "helpers";
import { setCreditReviewInformation } from "mappers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { CreditReviewInformationType, ErrorResponse } from "types";

type UseUpdateCreditReviewInformationMutationProps = {
	applicationId: string | number;
	creditReviewData: { [key: string]: any };
	setCreditReviewData: Function;
	setShowEditField: Function;
};

const useUpdateCreditReviewInformationMutation = ({
	applicationId,
	creditReviewData,
	setCreditReviewData,
	setShowEditField,
}: UseUpdateCreditReviewInformationMutationProps) => {
	const dispatch = useDispatch();

	const getCreditReviewValues: Function = values => {
		return Object.values(CreditReviewInformationFields).reduce(
			(acc, cur) => ({
				...acc,
				[cur]: isEmpty(values[cur])
					? creditReviewData[cur]
					: values[cur],
			}),
			{},
		);
	};

	return useMutation(
		(values: CreditReviewInformationType) => {
			const creditReviewValues = getCreditReviewValues(values);

			return autoChecklistService.updateMerchantInformation({
				applicationId,
				...creditReviewValues,
			});
		},
		{
			onSuccess(data) {
				setCreditReviewData(setCreditReviewInformation(data));
				dispatch(
					uiActions.showSuccessNotification({
						title: "Merchant information has been successfully updated.",
					}),
				);
				setShowEditField(false);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateCreditReviewInformationMutation;
